import { createStore } from 'effector';
import { createEffectJWT } from '../JWT';
import { getAccount, RGetAccount } from '../../apiRPC/account';

export const getAccountFx = createEffectJWT(getAccount, 'getAccountFx');
export const $account = createStore<RGetAccount | null>(null).on(
  getAccountFx.doneData,
  (_, payload) => payload,
);
